import { fmtMoney } from '../../../common/utils/money';

// Reparto por dueño de una línea de liquidación — filas alineadas nombre · % · monto.
// Los montos vienen congelados del backend (admin-billing-liquidations.md); acá solo se muestran (0001).
// Compartido por el detalle del batch (batch-detail) y la liquidación por vaca (cow-liquidation).
export default function SharesList({ shares }) {
    if (!shares?.length) return <span className="cat-table__empty">—</span>;
    return (
        <ul className="billing-shares">
            {shares.map((s, i) => {
                const planta = s.is_planta || !s.owner;
                return (
                    <li key={i} className={`billing-share ${planta ? 'billing-share--planta' : ''}`}>
                        <span className="billing-share__name">{planta ? 'Planta' : s.owner.name}</span>
                        <span className="billing-share__pct">{s.percent_snapshot != null ? `${s.percent_snapshot}%` : '—'}</span>
                        <span className="billing-share__amount">{fmtMoney(s.share_amount)}</span>
                    </li>
                );
            })}
        </ul>
    );
}
